import React from "react";
import icon1 from "../Assets/ClgInfo-Icons/icon-01.webp";

const OurInstituions = () => {
  return (
    <div id="inst" className="institutesBG">
      <div className="institutes-containor">
        <h1 className="institutes-title">INSTITUTES</h1>

        <div className="institues-box1">
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="#">
                {" "}
                <p>Technocrats Institute of Technology</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>Technocrats Institute of Technology (Excellence)</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>Technocrats Institute of Technology & Science</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>Technocrats Institute of Technology - CSE</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>Technocrats Institute of Nursing</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>TIT College of Pharmacy</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>Technocrats Institute of Commerce & Sciences</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>Technocrats Institute of Law</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>Technocrats Institute of Technology - MBA</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>Technocrats Institute of Paramedical Sciences</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>Technocrats Institute of Technology-Pharmacy</p>
              </a>
            </div>
          </div>
          <div className="institues-content">
            <div className="institues-icons">
              <img src={icon1} alt="" />
            </div>
            <div className="institues-des">
              <a href="">
                <p>Technocrats Institute of Technology & Science - Pharmacy</p>
              </a>
            </div>
          </div>
        </div>
        <div className="institues-box2">
          <div className="para-des">
            <p>
              Founded in 1999, Technocrats Group of Institutions is one of the
              largest and oldest NBA accredited educational groups in central
              India. It comprises 11 institutes with about 17,000+ students and
              1,469+ faculty members on campus. They offer undergraduate,
              postgraduate and doctoral courses in disciplines like engineering
              , management, pharmacy, commerce & sciences, law, as well as
              nursing and paramedical college.
            </p>
            <p>
              Technocrats group is the largest Technical Educational Group and
              AICTE approved college in Central India to have NBA Accreditation
              and is among the top engineering college with best placements in
              Bhopal. 3,217+ Students placed (2022 & 23 Batch).
            </p>
            <p>
            Awarded "Highest Placements and Best Academics in Central India Award - 2022" at 'Zee Madhya Pradesh Chhattisgarh Business Leadership Conclave.
            </p>
            <p>
            Recognized by Govt. of India & ASSOCHAM for “Excellence in Education” and “Campus Placements” continuously for the last two years.
            </p>
            <p>
            SAP, PWC, Morgan Stanley, Deloitte, Airbus, Amadeus, Bank of New York, E&Y, Goldman Sachs, S&P Global, Amazon, Paytm, IBM, Capgemini, TCS, Infosys, Wipro, Mphasis, Hexaware, Virtusa, HCL, Ashok Leyland, Tech Mahindra, TATA Motors, TATA Hitachi, SANY, Calvin Klein, Tommy Hilfiger, and many more prominent recruiters visited Technocrats Group last year.
            </p>
            <p>
            5,915+ Apple/HP/Lenovo Core i7/i5/i3 Computers, 552 Mbps lease line internet connection.
            </p>
            <p>
            Technocrats group holds a Global University Partnership and has MoU with University of Cincinnati, University of Central Missouri, Tokyo Institute of Technology for research, King Mongkut’s University of Technology, Namibia University of Science and Technology and California Baptist University for sharing student and faculty exchange programs and research collaborations.
            </p>
            <p>
            Technocrats is the top engineering college with best placements in Bhopal which also has Innovation Centres of Bosch, Dassault Systems, RedHat, Oracle, AWS, Bentley, Mitsubishi Electric, Siemens, Google and Texas Instruments to prepare students for industry.
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};
export default OurInstituions;
